import { render, staticRenderFns } from "./WhatsappTemplateBuilder.vue?vue&type=template&id=197a08d0&scoped=true&"
import script from "./WhatsappTemplateBuilder.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplateBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappTemplateBuilder.vue?vue&type=style&index=0&id=197a08d0&lang=scss&scoped=true&"
import style1 from "./WhatsappTemplateBuilder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a08d0",
  null
  
)

export default component.exports